import React from 'react';
import styled from 'styled-components';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core';
import { Grid, TextField, FormControlLabel, Checkbox, MenuItem } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { CardTemplateAttributeDb } from '../redux/cardTemplateAttributeDbSlice';
import { CardAttributeDb } from '../redux/cardAttributeDbSlice';
import { CardTemplateShapeDb } from '../redux/cardTemplateShapeDbSlice';
import { CardShapeDb } from '../redux/cardShapeDbSlice';
import { isLineStyle, FrameType } from '../redux/cardAttributeModelIndex';
import { Hash, deepCopy } from '../general';
import ColorPalette from './ColorPalette';

const NumberField = styled(TextField)`
  width: 40%;
  margin-right: 3px;
`

type EditItemFrameProps = {
  id?: string;
  item: CardTemplateAttributeDb | CardAttributeDb | CardTemplateShapeDb | CardShapeDb;
  changeItem: (item: any) => void;
}
const EditItemFrame: React.FC<EditItemFrameProps> = ({ id, item, changeItem }) => {
  type FramePropKeys = keyof FrameType;
  const lineStyles: Hash<string> = { 'solid': '実線', 'dotted': '点線', 'dashed': '破線', 'double': '二重線' };

  const changeFrameProp = (key: FramePropKeys, value: unknown) => {
    const newItem = deepCopy(item);
    if (key === 'display' && typeof value === 'boolean') newItem.frame.display = value;
    else if (key === 'color' && typeof value === 'string') newItem.frame.color = value;
    else if (key === 'lineStyle' && isLineStyle(value)) newItem.frame.lineStyle = value;
    else if (key === 'roundCorner' && typeof value === 'boolean') newItem.frame.roundCorner = value;
    else if (key === 'radius' && typeof value === 'number') {
      if (value >= 0) newItem.frame.radius = value;
      else newItem.frame.radius = 0;
    } else if (key === 'thickness' && typeof value === 'number') {
      if (value >= 0.1) newItem.frame.thickness = value;
      else newItem.frame.thickness = 0.1;
    }
    changeItem(newItem);
  }

  return (
    <Accordion>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
      >
      <FormControlLabel label="枠線表示"
        onClick={ev => ev.stopPropagation()}
        control={
          <Checkbox checked={item.frame.display} color="primary"
            onChange={(ev) => changeFrameProp('display', ev.currentTarget.checked)} />
        } />
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Grid container alignItems="center">
              <NumberField variant="outlined" label="太さ" size="small"
                type="number" inputProps={{step: 0.1}}
                value={item.frame.thickness} disabled={!item.frame.display}
                onChange={ev => changeFrameProp('thickness', Number(ev.target.value))}
              />
              <ColorPalette
                currentValue={item.frame.color}
                onChange={value => changeFrameProp('color', value)}
                style={{ marginLeft: 8 }}
                disabled={!item.frame.display}
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <TextField label="線種"
              select variant="outlined" size="small"
              value={item.frame.lineStyle} disabled={!item.frame.display}
              onChange={ev => changeFrameProp('lineStyle', ev.target.value)}
            >
              { Object.keys(lineStyles).map((key, ix) =>
                <MenuItem value={key} key={ix}>{lineStyles[key]}</MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item xs={12}>
            <FormControlLabel label="角丸" disabled={!item.frame.display}
              control={
                <Checkbox checked={item.frame.roundCorner} color="primary"
                  onChange={(ev) => changeFrameProp('roundCorner', ev.currentTarget.checked)} />
              } />
            <NumberField variant="outlined" label="半径" size="small"
              type="number" inputProps={{step: 0.1}}
              value={item.frame.radius} disabled={!item.frame.display || !item.frame.roundCorner}
              onChange={ev => changeFrameProp('radius', Number(ev.target.value))}
            />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}

export default EditItemFrame;
